export var attributionRequest = function (_a) {
    var appKey = _a.appKey, deviceId = _a.deviceId, attributes = _a.attributes;
    return fetch("https://track.saygames.io/attribution/web/".concat(appKey, "?device_id=").concat(deviceId, "&").concat(attributes));
};
//# sourceMappingURL=attribution.js.map